import { Foundation } from '@models';

export interface FoundationCommitteesResult {
  foundation: Foundation;
}
